import React from "react";
import { Switch, Redirect } from "react-router-dom";

import PublicRoute from "./PublicRoutes";
import LoginPage from "../components/Login/LoginPage";
import ForgetPassword from "../components/ForgetPassword/ForgetPassword";
import ResetPasswordThroughEmail from "../components/ResetPasswordThroughEmail/ResetPasswordThroughEmail";
import ResetPassword from "../components/Login/ResetPassword";
import DeleteAccount from "../components/Users/DeleteAccount";
import LoanTermsAndConditions from "../components/LendersT&C/LoanTermsAndConditions";
import CreditBookTermsAndConditions from "../components/LendersT&C/CreditBookTermsAndConditions";
import TermsAndConditions from "../components/__PoliciesAndTerms/TermsAndConditions";
import PrivacyPolicy from "../components/Policies/PrivacyPolicy/PrivacyPolicy";
import ConfirmEmail from "../components/Settings/UserMenu/ConfirmEmail/ConfirmEmail";
import DeliverymanPrivacyPolicy from "../components/Policies/PrivacyPolicy/DeliverymanPrivacyPolicy";
import RsoPrivacyPolicy from "../components/Policies/PrivacyPolicy/RsoPrivacyPolicy";

const DefaultRoutes = () => {
  return (
    <Switch>
      <Redirect strict exact from="/" to="/login" />
      <PublicRoute restricted exact component={LoginPage} path="/login" />
      <PublicRoute
        restricted
        exact
        component={DeleteAccount}
        path="/account/deleteaccount"
      />
      <PublicRoute
        restricted
        exact
        component={TermsAndConditions}
        path="/account/termsandconditions"
      />
      <PublicRoute
        restricted
        exact
        component={LoanTermsAndConditions}
        path="/Lender/termsandconditions"
      />
      <PublicRoute
        restricted
        exact
        component={CreditBookTermsAndConditions}
        path="/Lender/CreditBookTermsAndConditions"
      />
      <PublicRoute
        restricted
        exact
        component={PrivacyPolicy}
        path="/PrivacyPolicy"
      />
      <PublicRoute
        restricted
        exact
        component={DeliverymanPrivacyPolicy}
        path="/DeliverymanPrivacyPolicy"
      />
      <PublicRoute
        restricted
        exact
        component={RsoPrivacyPolicy}
        path="/PrivacyPolicyRSO"
      />
      <PublicRoute
        restricted
        exact
        component={ForgetPassword}
        path="/ForgetPassword"
      />
      <PublicRoute
        restricted
        exact
        component={ResetPasswordThroughEmail}
        path="/ResetPasswordThroughEmail"
      />
      <PublicRoute
        restricted
        exact
        component={ConfirmEmail}
        path="/ConfirmEmail"
      />
      <PublicRoute
        restricted
        // exact
        component={ResetPassword}
        path="/resetpassword/:username/:code"
      />
      <PublicRoute path="*">
        <Redirect to="/" />
      </PublicRoute>
    </Switch>
  );
};

export default DefaultRoutes;
